let csvw_url = 'https://www.csvw.com';
export default {
  // kv
  workspace: {
    videourl: csvw_url + "/u/cms/www/202106/17224828K6m9.mp4"
  },
  // 车型素材
  workspace2: {
    neishi: Array.from({
      length: 72
    }).map((item, i) => {
      return require(`../../assets/id6/imgs/neishi/${i+1}.jpg`)
    }),
    waiguan: Array.from({
      length: 93
    }).map((item, i) => {
      return require(`../../assets/id6/imgs/waiguan/${i+1}.jpg`)
    }),
    qita: Array.from({
      length: 19
    }).map((item, i) => {
      return require(`../../assets/id6/imgs/qita/${i+1}.jpg`)
    }),
    shipin: [
      require("../../assets/id6/imgs/shipin/0.jpg"),
      require("../../assets/id6/imgs/shipin/1.jpg"),
      require("../../assets/id6/imgs/shipin/2.jpg"),
      require("../../assets/id6/imgs/shipin/3.jpg"),
      require("../../assets/id6/imgs/shipin/4.jpg"),
    ],
    videourl: [
      csvw_url + "/u/cms/www/202106/151709349S84.mp4",
      csvw_url + "/u/cms/www/202106/03160934657Y.mp4",
      csvw_url + "/u/cms/www/202106/03160901qxpR.mp4",
      csvw_url + "/u/cms/www/202106/03160920y8d0.mp4",
      csvw_url + "/u/cms/www/202106/03160940480i.mp4"
    ],
  },
  // 新闻稿
  workspace3: {
    list: [{
        title: '239,888元-335,888元 智能大空间',
        title1: '大众e起行 上汽大众ID.6 X上市',
        subtitle: '6月17日，上汽大众全新旗舰纯电SUV ID.6 X上市，这款七座智能纯电SUV，实力全面强劲，以大空间和高智能为e世代的新新家庭用户带来高品质的用车选择。',
        imgurl: require("../../assets/id6/imgs/xinwen/1.png"),
        imgurlMobile: require("../../assets/id6/imgsMobile/xinwen/1.png"),
        url: 'https://www.csvw.com/csvw-website/news/dz-brand-news.html?newsid=3066'
      },
      {
        title: 'ID.6 X到底如何',
        title1: '看看媒体大佬们怎么说',
        subtitle: '自上海车展亮相以来，ID.6 X受到了市场与消费者的广泛关注，目前，已有媒体陆续发布专业测评报道。各位持币观望的e世代新新人类，不妨先看看媒体大佬们对ID.6X的评价。',
        imgurl: require("../../assets/id6/imgs/xinwen/2.png"),
        imgurlMobile: require("../../assets/id6/imgsMobile/xinwen/2.png"),
        url: 'https://www.csvw.com/csvw-website/news/dz-brand-news.html?newsid=3061'
      },
      {
        title: 'e世代e出行看这里',
        title1: 'ID.6 X有多智能了解一下',
        subtitle: '上汽大众全新纯电SUV ID.6 X自上海车展亮相并开启预订以来，持续收获高度关注。ID.6 X定位于打造品质标杆的七座智能纯电SUV，成为e世代e出行的不二之选。如今，“智能化”已成为用户选购纯电车型时考虑的高频词汇，ID.6 X不仅外观出众，内涵更是丰富，这就来了解一下ID.6 X有多智能吧。',
        imgurl: require("../../assets/id6/imgs/xinwen/3.png"),
        imgurlMobile: require("../../assets/id6/imgsMobile/xinwen/3.png"),
        url: 'https://www.csvw.com/csvw-website/news/dz-brand-news.html?newsid=3041'
      }
    ]
  },
  // 大咖点评
  workspace4: {
    list: [{
        title: require("../../assets/id6/imgs/logo/1.png"),
        titleMobile: require("../../assets/id6/imgs/logo/1.png"),
        subtitle: 'ID.6 X整车造型的型面饱满有力，线条动感流畅，创新感性的设计元素在匹配电动汽车独有气质的同时，将数字、科技、未来的感觉表现得淋漓尽致。',
        imgurl: require("../../assets/id6/imgs/daka/1.jpg"),
        imgurlMobile: require("../../assets/id6/imgsMobile/daka/1.jpg"),
        url: 'http://auto.news18a.com/news/storys_154667.html'
      },
      {
        title: require("../../assets/id6/imgs/logo/2.png"),
        titleMobile: require("../../assets/id6/imgs/logo/2.png"),
        subtitle: 'ID.6 X最大功率为150kW，峰值扭矩为310Nm，动力性能强劲、高效。',
        imgurl: require("../../assets/id6/imgs/daka/2.jpg"),
        imgurlMobile: require("../../assets/id6/imgsMobile/daka/2.jpg"),
        url: 'https://www.autohome.com.cn/drive/202105/1156952.html'
      },
      {
        title: require("../../assets/id6/imgs/logo/3.png"),
        titleMobile: require("../../assets/id6/imgs/logo/3.png"),
        subtitle: 'ID.6 X的前包围处添加点阵式菱形镀铬装饰，由中间延伸至两侧，拉伸了车头的横向视觉效果，增加了前脸层次感。',
        imgurl: require("../../assets/id6/imgs/daka/3.jpg"),
        imgurlMobile: require("../../assets/id6/imgsMobile/daka/3.jpg"),
        url: 'https://news.yiche.com/shijiatiyan/20210525/1014650265.html'
      },
      {
        title: require("../../assets/id6/imgs/logo/4.png"),
        titleMobile: require("../../assets/id6/imgs/logo/4.png"),
        subtitle: 'ID.6 X贯穿式尾灯是尾部一大亮点，纤细灯带与两侧3D LED灯组自然的衔接，拉宽了尾部视觉宽度。全新扁平化发光LOGO装配在中间，简约纯粹又颇具科技感。',
        imgurl: require("../../assets/id6/imgs/daka/4.jpg"),
        imgurlMobile: require("../../assets/id6/imgsMobile/daka/4.jpg"),
        url: 'https://drive.xcar.com.cn/202105/news_2059335_1.html'
      },
      {
        title: require("../../assets/id6/imgs/logo/5.png"),
        titleMobile: require("../../assets/id6/imgs/logo/5.png"),
        subtitle: 'ID.6 X灯腔内的矩阵LED大灯富有三维变化，车灯整体造型体量感十足，轮廓延伸至车身两侧，与醒目的IQ Light标识相融合，营造出一种蓄势待发的神情。',
        imgurl: require("../../assets/id6/imgs/daka/5.jpg"),
        imgurlMobile: require("../../assets/id6/imgsMobile/daka/5.jpg"),
        url: 'https://www.pcauto.com.cn/pingce/2525/25250031_2.html'
      },
      {
        title: require("../../assets/id6/imgs/logo/6.png"),
        titleMobile: require("../../assets/id6/imgs/logo/6.png"),
        subtitle: 'ID.6 X车身侧面造型较为简约，车顶流线从C柱开始向下滑落，线条流畅，看上去十分舒适。',
        imgurl: require("../../assets/id6/imgs/daka/6.jpg"),
        imgurlMobile: require("../../assets/id6/imgsMobile/daka/6.jpg"),
        url: 'https://auto.sina.com.cn/estation/2021-05-26/detail-ikmxzfmm4689549.shtml'
      },
      {
        title: require("../../assets/id6/imgs/logo/7.png"),
        titleMobile: require("../../assets/id6/imgs/logo/7.png"),
        subtitle: 'ID.6 X将搭载132kW、150kW和225kW三种动力版本，并且提供前驱和四驱两种驱动。',
        imgurl: require("../../assets/id6/imgs/daka/7.jpg"),
        imgurlMobile: require("../../assets/id6/imgsMobile/daka/7.jpg"),
        url: 'https://c.m.163.com/news/a/GATLV0US0008856V.html?spss=newsapp'
      },
      {
        title: require("../../assets/id6/imgs/logo/8.png"),
        titleMobile: require("../../assets/id6/imgs/logo/8.png"),
        subtitle: 'ID.6 X的IQ. Light LED矩阵式智能大灯，采用12像素，远近光共17颗LED，亮度750lm，夜间照明十分绚丽夺目。并配有自适应远近光等各种功能，让用户夜间出行得到视觉效果。',
        imgurl: require("../../assets/id6/imgs/daka/8.jpg"),
        imgurlMobile: require("../../assets/id6/imgsMobile/daka/8.jpg"),
        url: 'http://www.huanqiuauto.com/news/20210527/1256066_1.html'
      },
      {
        title: require("../../assets/id6/imgs/logo/9.png"),
        titleMobile: require("../../assets/id6/imgs/logo/9.png"),
        subtitle: 'ID.6 X装备的12英寸中控屏采用了大众最新的MOS 4.0多媒体系统，囊括了近乎车内所有的功能操作，无论是界面还是流畅性都拥有着上佳的表现。',
        imgurl: require("../../assets/id6/imgs/daka/9.jpg"),
        imgurlMobile: require("../../assets/id6/imgsMobile/daka/9.jpg"),
        url: 'https://www.youcheyihou.com/news/1150585'
      },
      {
        title: require("../../assets/id6/imgs/logo/10.png"),
        titleMobile: require("../../assets/id6/imgs/logo/10.png"),
        subtitle: 'ID.6 X搭载了83.4kWh的三元锂电子动力电池，但通过电控优化，把NEDC续航做到了588公里。',
        imgurl: require("../../assets/id6/imgs/daka/10.jpg"),
        imgurlMobile: require("../../assets/id6/imgsMobile/daka/10.jpg"),
        url: 'https://www.sohu.com/a/469196254_400718'
      },
      // {
      //   title: require("../../assets/id6/imgs/logo/11.png"),
      //   titleMobile: require("../../assets/id6/imgs/logo/11.png"),
      //   subtitle: 'ID.6 X不仅支持手机远程控制车辆，车主还可以使用智能手表控制车内空调、车辆解锁等功能。',
      //   imgurl: require("../../assets/id6/imgs/daka/11.jpg"),
      //   imgurlMobile: require("../../assets/id6/imgsMobile/daka/11.jpg"),
      //   url: 'https://www.qctt.cn/news/002_2892080'
      // },
      {
        title: require("../../assets/id6/imgs/logo/12.png"),
        titleMobile: require("../../assets/id6/imgs/logo/12.png"),
        subtitle: 'ID.6 X仪表、中央触控、AR-HUD增强现实抬头显示组成的三屏交互架构摒弃了堆砌功能按键的传统交互思路，更具科技感和便利性。',
        imgurl: require("../../assets/id6/imgs/daka/12.jpg"),
        imgurlMobile: require("../../assets/id6/imgsMobile/daka/12.jpg"),
        url: 'https://www.163.com/dy/article/GBAUN0IK051286OQ.html'
      },
      {
        title: require("../../assets/id6/imgs/logo/13.png"),
        titleMobile: require("../../assets/id6/imgs/logo/13.png"),
        subtitle: 'ID.6 X搭载了上汽大众最新一代智慧车联系统，结合上汽大众超级APP，让车主畅享包含智慧导航、智联控车、智享娱乐、智能家居、智能音箱等一系列在线服务。',
        imgurl: require("../../assets/id6/imgs/daka/13.jpg"),
        imgurlMobile: require("../../assets/id6/imgsMobile/daka/13.jpg"),
        url: 'https://www.163.com/dy/article/GBB7A0SO05279PH1.html'
      },
      {
        title: require("../../assets/id6/imgs/logo/14.png"),
        titleMobile: require("../../assets/id6/imgs/logo/14.png"),
        subtitle: 'ID.6 X贯通式仪表台设计与多处悬浮式设计的应用，视觉上拉宽内饰空间效果的同时，层次感也更加丰富。',
        imgurl: require("../../assets/id6/imgs/daka/14.jpg"),
        imgurlMobile: require("../../assets/id6/imgsMobile/daka/14.jpg"),
        url: 'https://www.xcar.com.cn/bbs/viewthread.php?tid=96536598'
      },
      {
        title: require("../../assets/id6/imgs/logo/15.png"),
        titleMobile: require("../../assets/id6/imgs/logo/15.png"),
        subtitle: 'ID.6 X车长4876mm、宽1848mm、高1680mm，轴距长达2965mm，提供6座/7座选择，空间阔绰，布局灵活。',
        imgurl: require("../../assets/id6/imgs/daka/15.jpg"),
        imgurlMobile: require("../../assets/id6/imgsMobile/daka/15.jpg"),
        url: 'https://news.yiche.com/hao/wenzhang/46949071/'
      },
      {
        title: require("../../assets/id6/imgs/logo/16.png"),
        titleMobile: require("../../assets/id6/imgs/logo/16.png"),
        subtitle: 'ID.6 X拥有全视野景观天幕，可开启全景天窗为驾乘人员在视觉上提供通透的景观空间。',
        imgurl: require("../../assets/id6/imgs/daka/16.jpg"),
        imgurlMobile: require("../../assets/id6/imgsMobile/daka/16.jpg"),
        url: 'https://news.yiche.com/hao/wenzhang/46878380'
      },
      {
        title: require("../../assets/id6/imgs/logo/17.png"),
        titleMobile: require("../../assets/id6/imgs/logo/17.png"),
        subtitle: 'ID.6 X配备了隐藏式门把手，在电子开启的基础上还保留了机械结构。所以，即便是遭遇车辆没电时，大力向上提拉，也可开启车门。',
        imgurl: require("../../assets/id6/imgs/daka/17.jpg"),
        imgurlMobile: require("../../assets/id6/imgsMobile/daka/17.jpg"),
        url: 'https://www.qctt.cn/news/1011466'
      },
      {
        title: require("../../assets/id6/imgs/logo/18.png"),
        titleMobile: require("../../assets/id6/imgs/logo/18.png"),
        subtitle: 'ID.6 X的多层结构电池包采用4重电芯安全设计，并经过338项电池包安全测试，保障电池包在各种极端工况下的安全。',
        imgurl: require("../../assets/id6/imgs/daka/18.jpg"),
        imgurlMobile: require("../../assets/id6/imgsMobile/daka/18.jpg"),
        url: 'https://www.qctt.cn/news/1010695'
      },
      {
        title: require("../../assets/id6/imgs/logo/19.png"),
        titleMobile: require("../../assets/id6/imgs/logo/19.png"),
        subtitle: 'ID.6 X搭载的IQ. Drive L2级驾驶辅助，支持方向盘脱手检测及带Stop & Go自动跟车启停，行车更加智能、安全。',
        imgurl: require("../../assets/id6/imgs/daka/19.jpg"),
        imgurlMobile: require("../../assets/id6/imgsMobile/daka/19.jpg"),
        url: 'https://www.qctt.cn/news/1010524'
      },
      {
        title: require("../../assets/id6/imgs/logo/20.png"),
        titleMobile: require("../../assets/id6/imgs/logo/20.png"),
        subtitle: 'ID.6 X 30色内饰氛围灯可以无级调节，多层布置让整车氛围更加高级。ID. Light 光语系统还会伴随操作指令进行交互闪烁。',
        imgurl: require("../../assets/id6/imgs/daka/20.jpg"),
        imgurlMobile: require("../../assets/id6/imgsMobile/daka/20.jpg"),
        url: 'https://chejiahao.autohome.com.cn/info/8692384'
      },
      {
        title: require("../../assets/id6/imgs/logo/21.png"),
        titleMobile: require("../../assets/id6/imgs/logo/21.png"),
        subtitle: 'ID.6 X轮毂采用21英寸双5幅双配色刀锋造型轮毂，更加的运动。',
        imgurl: require("../../assets/id6/imgs/daka/21.jpg"),
        imgurlMobile: require("../../assets/id6/imgsMobile/daka/21.jpg"),
        url: 'https://chejiahao.autohome.com.cn/info/8681570'
      },
      {
        title: require("../../assets/id6/imgs/logo/22.png"),
        titleMobile: require("../../assets/id6/imgs/logo/22.png"),
        subtitle: 'ID.6 X延续大众“光语互动”家族化内饰设计风格，多种材质与几何纹理交错配置的中控台给人以丰富的视觉体验，兼顾品质与豪华。',
        imgurl: require("../../assets/id6/imgs/daka/22.jpg"),
        imgurlMobile: require("../../assets/id6/imgsMobile/daka/22.jpg"),
        url: 'https://www.sohu.com/a/469753808_120144967'
      },
      // {
      //   title: require("../../assets/id6/imgs/logo/23.png"),
      //   titleMobile: require("../../assets/id6/imgs/logo/23.png"),
      //   subtitle: 'ID.6 X 5.3英寸悬浮式全液晶仪表盘内置续航、动能回收、胎压监测、导航、多媒体等功能，显示效果十分细腻。',
      //   imgurl: require("../../assets/id6/imgs/daka/23.jpg"),
      //   imgurlMobile: require("../../assets/id6/imgsMobile/daka/23.jpg"),
      //   url: 'http://www.myzaker.com/article/60b4ae19b15ec067ec12c603/'
      // },
      {
        title: require("../../assets/id6/imgs/logo/24.png"),
        titleMobile: require("../../assets/id6/imgs/logo/24.png"),
        subtitle: 'ID.6 X AR-HUD增强现实抬头显示，运用增强现实技术将行车信息及路况导航信息投射在前挡风玻璃，与前方道路视觉融合，提高驾驶的安全性。',
        imgurl: require("../../assets/id6/imgs/daka/24.jpg"),
        imgurlMobile: require("../../assets/id6/imgsMobile/daka/24.jpg"),
        url: 'https://m.sohu.com/a/468543042_383324/?pvid=000115_3w_a'
      },
      {
        title: require("../../assets/id6/imgs/logo/25.png"),
        titleMobile: require("../../assets/id6/imgs/logo/25.png"),
        subtitle: 'ID.6 X凹凸有致的各个控制区域突显出更强的层次感，金属拉丝工艺的饰板提升了车内整体的档次，两块悬浮式液晶屏又增加了科技感。',
        imgurl: require("../../assets/id6/imgs/daka/25.jpg"),
        imgurlMobile: require("../../assets/id6/imgsMobile/daka/25.jpg"),
        url: 'http://www.buyevcar.com.cn/news/4421.html'
      },
      {
        title: require("../../assets/id6/imgs/logo/26.png"),
        titleMobile: require("../../assets/id6/imgs/logo/26.png"),
        subtitle: 'ID.6 X三幅式平底方向盘握感厚实，两侧的功能按键在取消物理按键后，提高了整体档次感。',
        imgurl: require("../../assets/id6/imgs/daka/26.jpg"),
        imgurlMobile: require("../../assets/id6/imgsMobile/daka/26.jpg"),
        url: 'http://www.21cnev.com/html/202105/788070_1.html'
      },
    ]
  },
  // 媒体试驾
  workspace5: {
    // 移动端
    shipin: [
      require("../../assets/id6/imgs/shijia/1.jpg"),
      require("../../assets/id6/imgs/shijia/2.jpg"),
      require("../../assets/id6/imgs/shijia/3.jpg"),
      require("../../assets/id6/imgs/shijia/4.jpg"),
      require("../../assets/id6/imgs/shijia/5.jpg"),
      require("../../assets/id6/imgs/shijia/6.jpg"),
    ],
    // PC端
    shipinPC: [
      [
        require("../../assets/id6/imgs/shijia/1.jpg"),
        require("../../assets/id6/imgs/shijia/2.jpg"),
        require("../../assets/id6/imgs/shijia/3.jpg"),
      ],
      [
        require("../../assets/id6/imgs/shijia/4.jpg"),
        require("../../assets/id6/imgs/shijia/5.jpg"),
        require("../../assets/id6/imgs/shijia/6.jpg"),
      ],
    ],
    // 封面
    fengurl: [
      require("../../assets/id6/imgs/shijia/1.jpg"),
      require("../../assets/id6/imgs/shijia/2.jpg"),
      require("../../assets/id6/imgs/shijia/3.jpg"),
      require("../../assets/id6/imgs/shijia/4.jpg"),
      require("../../assets/id6/imgs/shijia/5.jpg"),
      require("../../assets/id6/imgs/shijia/6.jpg"),
    ],
    videourl: [
      csvw_url + "/u/cms/www/202106/0213404598SK.mp4",
      csvw_url + "/u/cms/www/202106/02134045156t.mp4",
      csvw_url + "/u/cms/www/202106/02134057Q215.mp4",
      csvw_url + "/u/cms/www/202106/0310210606bJ.mp4",
      csvw_url + "/u/cms/www/202106/02134105753O.mp4",
      csvw_url + "/u/cms/www/202106/02134037go3O.mp4",
    ],
  },
  // 现场直击(作废板块)
  // 现场直击
  workspace6: {
    // 移动端
    shipin: [
      require("../../assets/id6/imgs/xianchang/1.jpg"),
      require("../../assets/id6/imgs/xianchang/2.jpg"),
      require("../../assets/id6/imgs/xianchang/3.jpg"),
      require("../../assets/id6/imgs/xianchang/1.jpg"),
      require("../../assets/id6/imgs/xianchang/2.jpg"),
      require("../../assets/id6/imgs/xianchang/3.jpg"),
      require("../../assets/id6/imgs/xianchang/1.jpg"),
      require("../../assets/id6/imgs/xianchang/2.jpg"),
      require("../../assets/id6/imgs/xianchang/3.jpg"),
    ],
    // PC端
    shipinPC: [
      [
        require("../../assets/id6/imgs/xianchang/1.jpg"),
        require("../../assets/id6/imgs/xianchang/2.jpg"),
        require("../../assets/id6/imgs/xianchang/3.jpg"),
      ],
      [
        require("../../assets/id6/imgs/xianchang/1.jpg"),
        require("../../assets/id6/imgs/xianchang/2.jpg"),
        require("../../assets/id6/imgs/xianchang/3.jpg"),
      ],
      [
        require("../../assets/id6/imgs/xianchang/1.jpg"),
        require("../../assets/id6/imgs/xianchang/2.jpg"),
        require("../../assets/id6/imgs/xianchang/3.jpg"),
      ],
    ],
    // 封面
    fengurl: [
      require("../../assets/id6/imgs/xianchang/1-1.jpg"),
      require("../../assets/id6/imgs/xianchang/2-1.jpg"),
      require("../../assets/id6/imgs/xianchang/3-1.jpg"),
      require("../../assets/id6/imgs/xianchang/4-1.jpg"),
      require("../../assets/id6/imgs/xianchang/5-1.jpg"),
      require("../../assets/id6/imgs/xianchang/6-1.jpg"),
      require("../../assets/id6/imgs/xianchang/7-1.jpg"),
      require("../../assets/id6/imgs/xianchang/8-1.jpg"),
      require("../../assets/id6/imgs/xianchang/9-1.jpg"),
    ]
  }
}